import { FC } from 'react'
import useWatch from '../hooks/use-watch'
import { useGetStampsQuery } from '../../../../store/api/stamps-api'
import { EndpointQueryParameters } from '../../../../types/strapi/strapi'
import { Alert, ConfigProvider, Space, Table, theme } from 'antd'
import { StampSearchTableContext } from '../stamp-search-control'
import { columns } from '../columns'
import Stamp from '../../../../types/api/stamp'
import Title from 'antd/es/typography/Title'
import { HALF_ROTATION_ROLLER } from '../../../../helpers/format-roller-display'

interface SameStampsProps {
    onSelectStamp: (stamp: Stamp) => void
    halfRotation?: boolean
    halfRotationRollerDocIds?: string[]
}

const SameStamps: FC<SameStampsProps> = ({
    onSelectStamp,
    halfRotation,
    halfRotationRollerDocIds,
}) => {
    const width = useWatch('width') || 0
    const length = useWatch('length') || 0
    const shape = useWatch('shape')
    const v = 5
    const query: EndpointQueryParameters = {
        filters: {
            width: { $between: [String(width - v), String(width + v)] },
            length: { $between: [String(length - v), String(length + v)] },
            shape: { $contains: shape },
            ...(halfRotation && halfRotationRollerDocIds?.length
                ? { roller: { documentId: { $in: halfRotationRollerDocIds } } }
                : {}),
        },
        sort: ['width', 'length'],
        populate: '*',
    }
    const waitingForHalfRotationRollers =
        Boolean(halfRotation) && halfRotationRollerDocIds === undefined
    const halfRotationRollerMissing =
        Boolean(halfRotation) && halfRotationRollerDocIds?.length === 0
    const { data } = useGetStampsQuery(query, {
        skip: !width || !length || waitingForHalfRotationRollers || halfRotationRollerMissing,
    })
    // const sortStamps = getSortFunc(width, length)
    // const stamps = [...(data?.data || [])].sort(sortStamps)
    // const stamps = sortByCustomPriority([...(data?.data || [])], width, length)
    const stamps = waitingForHalfRotationRollers
        ? []
        : (data?.data || []).filter(s =>
              halfRotation ? Number(s.roller?.roller) === HALF_ROTATION_ROLLER : true
          )

    // TODO: сортировать сначала с минимальным расхождением!

    return (
        <>
            {stamps.length > 0 ? (
                <Space style={{ width: '100%' }} direction={'vertical'}>
                    <Title level={3}>Список похожих штампов</Title>
                    <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
                        <StampSearchTableContext.Provider value={{ onSelectStamp }}>
                            <Table
                                dataSource={stamps}
                                columns={columns}
                                pagination={false}
                                rowKey={x => x.id}
                                showSorterTooltip
                            />
                        </StampSearchTableContext.Provider>
                    </ConfigProvider>
                </Space>
            ) : width && length && !waitingForHalfRotationRollers && stamps.length === 0 ? (
                <Alert
                    type={'warning'}
                    message={'Нет подходящего штампа, укажите новый'}
                    showIcon
                />
            ) : null}
        </>
    )
}

export default SameStamps

// function getSortFunc(targetWidth: number, targetLength: number) {
//     // Функция для вычисления "расстояния" до целевых значений
//     // const calculateDistance = (item: Stamp) => {
//     //     const widthDiff = Math.abs(item.width - targetWidth)
//     //     const lengthDiff = Math.abs(item.length - targetLength)
//     //     return widthDiff + lengthDiff // Сумма абсолютных разниц
//     // }

//     const calculateDistance = (item: Stamp) => {
//         return Math.sqrt(
//             Math.pow(item.width - targetWidth, 2) + Math.pow(item.length - targetLength, 2)
//         )
//     }

//     // Сортировка массива
//     return function sort(a: Stamp, b: Stamp) {
//         const distanceA = calculateDistance(a)
//         const distanceB = calculateDistance(b)

//         // Сначала сравниваем по сумме разниц
//         if (distanceA !== distanceB) {
//             return distanceA - distanceB
//         }

//         // При равенстве суммы - приоритет у width
//         return Math.abs(a.width - targetWidth) - Math.abs(b.width - targetWidth)
//     }
// }

// type Item = {
//     width: number
//     length: number
// }

// function sortByCustomPriority(data: Item[], targetWidth: number, targetLength: number): Item[] {
//     return data.sort((a, b) => {
//         const keyA = getPriorityKey(a, targetWidth, targetLength)
//         const keyB = getPriorityKey(b, targetWidth, targetLength)

//         for (let i = 0; i < keyA.length; i++) {
//             if (keyA[i] !== keyB[i]) {
//                 return keyA[i] - keyB[i]
//             }
//         }

//         return 0
//     })
// }

// function getPriorityKey(item: Item, targetWidth: number, targetLength: number): number[] {
//     const dw = Math.abs(item.width - targetWidth)
//     const dl = Math.abs(item.length - targetLength)

//     // Проверка на специальные приоритетные условия до ±5
//     for (let range = 1; range <= 5; range++) {
//         if (isApproxEqual(dw, range) && isApproxEqual(dl, 0)) {
//             return [range * 2 - 2, dw + dl, dw, dl] // шаги 0, 2, 4, 6, 8
//         }
//         if (isApproxEqual(dw, 0) && isApproxEqual(dl, range)) {
//             return [range * 2 - 1, dw + dl, dw, dl] // шаги 1, 3, 5, 7, 9
//         }
//     }

//     // Всё остальное: сортируем по расстоянию и деталям
//     return [1000 + dw + dl, dw + dl, dw, dl]
// }

// // Из-за возможных дробей сравнение с небольшим допуском
// function isApproxEqual(a: number, b: number, epsilon = 0.0001): boolean {
//     return Math.abs(a - b) < epsilon
// }
